(()=>{
  const formatText=root=>{
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const changes=[];
    while(walker.nextNode()){
      const node=walker.currentNode;
      if(node.parentElement?.closest('script,style,textarea,input,code,pre,[contenteditable]'))continue;
      const text=node.nodeValue;
      const formatted=text.replace(/\bAED\s*([\d,]+(?:\.\d{2})?)/g,(_,amount)=>`${amount.replace(/\.00$/,'')} AED`).replace(/([\d,]+)\.00\s+AED\b/g,'$1 AED');
      if(formatted!==text)changes.push([node,formatted]);
    }
    changes.forEach(([node,text])=>{node.nodeValue=text;});
  };
  formatText(document.body);
  let scheduled=false;
  const observer=new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;observer.disconnect();formatText(document.body);observer.observe(document.body,{childList:true,subtree:true,characterData:true});});});
  observer.observe(document.body,{childList:true,subtree:true,characterData:true});
})();
